module.exports = __webpack_public_path__ + "img/daishenheen.54148534.jpg";